// extracted by mini-css-extract-plugin
export default {"login_header":"LoginHeader_login_header__kcC5u"};